



















































































import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import DeliveryTab from '@/components/delivery/DeliveryTab.vue';
import {ncpPopup} from '@/utils/ncp';
import {htmlRestore} from '@/utils/formatUtils';
@Component({
  components: {
    PageTitle,
    DeliveryTab
  }
})
export default class DeliveryWarehouseList extends Vue {
  private warehouses: any[] = [];
  private selectedWarehouses: number[] = [];
  private htmlRestore = htmlRestore;
  private fetchWarehouses() {
    this.$api.getWarehouses().then(ret => {
      this.warehouses = ret.data as any;
    });
  }
  created() {
    this.fetchWarehouses();
  }
  private clickCheckBox(checked: boolean, warehouseNo: number) {
    if (checked) {
      this.selectedWarehouses.push(warehouseNo);
    } else {
      const ret = this.selectedWarehouses.indexOf(warehouseNo);
      if (ret > -1) {
        this.selectedWarehouses.splice(ret, 1);
      }
    }
  }
  private checkAll(checked: boolean) {
    if (checked) {
      this.warehouses.forEach(item => {
        this.selectedWarehouses.push(item.warehouseNo);
      });
    } else {
      this.selectedWarehouses = [];
    }
  }
  private deleteWarehouse() {
    if (this.selectedWarehouses) {
      if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_LIST_CONFIRM1').toString())) {
        this.$api.deleteWarehousesBulk({params: {warehouseNos: this.selectedWarehouses.toString()}}).then(() => {
          this.selectedWarehouses = [];
          this.fetchWarehouses();
        });
      }
    } else {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_LIST_ALERT1'));
    }
  }
  private add() {
    ncpPopup('/warehouse/addForm', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_LIST_FORWARDING_PLACE').toString(), 1024, 500);
  }
  private modify(warehouseNo: number) {
    ncpPopup(`/warehouse/addForm?warehouseNo=${warehouseNo}`, this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_LIST_REVISION').toString(), 1024, 500);
  }
}
